module.exports = __webpack_public_path__ + "static/media/step-item-3.10b82611.svg";